<template>
    <div :class="containerClass">
        <ul :class="tabsClass">
            <li class="nav-item" v-for="pane in panes" :key="pane.id">
                <a href="#" :class="linkClass(pane)" @click.prevent="selectPane(pane)">
                    <span :class="`icon mdi mdi-${pane.icon}`" v-if="pane.icon"></span>
                    {{ pane.label }}
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div :class="paneClass(selected)">
                <slot :pane="selected" v-if="selected"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            panes: Array,
            color: String,
            cards: Boolean,
            left: Boolean,
        },

        data: () => ({
            selected: null,
        }),

        computed: {
            containerClass: vm => ({
                'tab-container': true,
                'tab-left': vm.left,
            }),

            tabsClass: vm => ({
                'nav nav-tabs': true,
                'nav-tabs-classic': !vm.cards,
                [`nav-tabs-${vm.color}`]: !!vm.color,
                'card-nav-tabs': vm.cards,
            }),

            linkClass: vm => pane => ({
                'nav-link': true,
                'active show': vm.selected === pane,
                disabled: pane.disabled,
            }),

            paneClass: vm => pane => ({
                'tab-pane': true,
                'active show': vm.selected === pane,
            }),
        },

        methods: {
            selectPane(pane) {
                this.selected = pane;
            },
        },

        mounted() {
            this.selected = this.panes.find(pane => pane.active);

            if (!this.selected) {
                this.selected = this.panes[0];
            }
        },
    };
</script>
